export function PersonalDataUtils(t: any) {
  return {
    literals: {
      title: t("PersonalDataUtils.literals.title"),
      savebutton: t("PersonalDataUtils.literals.savebutton"),
      personalinfo: {
        title: t("PersonalDataUtils.literals.personalinfo.title"),
        subtitle: t("PersonalDataUtils.literals.personalinfo.subtitle"),
        birthdaytitle: t(
          "PersonalDataUtils.literals.personalinfo.birthdaytitle"
        ),
        form: {
          formErrors: {
            required: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.required"
            ),
            name: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.name"
            ),
            surname: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.surname"
            ),
            surname2: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.surname2"
            ),
            day: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.day"
            ),
            month: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.month"
            ),
            year: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.year"
            ),
            prefixNumber: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.prefixNumber"
            ),
            phoneNumber: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.phoneNumber"
            ),
            email: t(
              "PersonalDataUtils.literals.personalinfo.form.formErrors.email"
            ),
          },
          email: {
            label: t(
              "PersonalDataUtils.literals.personalinfo.form.email.label"
            ),
          },
          name: {
            label: t("PersonalDataUtils.literals.personalinfo.form.name.label"),
          },
          surname: {
            label: t(
              "PersonalDataUtils.literals.personalinfo.form.surname.label"
            ),
          },
          surname2: {
            label: t(
              "PersonalDataUtils.literals.personalinfo.form.surname2.label"
            ),
          },
          prefix: {
            label: t(
              "PersonalDataUtils.literals.personalinfo.form.prefix.label"
            ),
          },
          phone: {
            label: t(
              "PersonalDataUtils.literals.personalinfo.form.phone.label"
            ),
          },
          day: {
            label: t("PersonalDataUtils.literals.personalinfo.form.day.label"),
          },
          month: {
            label: t(
              "PersonalDataUtils.literals.personalinfo.form.month.label"
            ),
          },
          year: {
            label: t("PersonalDataUtils.literals.personalinfo.form.year.label"),
          },
        },
      },
      idinfo: {
        title: t("PersonalDataUtils.literals.idinfo.title"),
        subtitle: t("PersonalDataUtils.literals.idinfo.subtitle"),
        documentType: {
          requiredError: t(
            "PersonalDataUtils.literals.idinfo.documentType.requiredError"
          ),
          dni: {
            title: t(
              "PersonalDataUtils.literals.idinfo.documentType.dni.title"
            ),
            subtitle: t(
              "PersonalDataUtils.literals.idinfo.documentType.dni.subtitle"
            ),
            errormsg: t(
              "PersonalDataUtils.literals.idinfo.documentType.dni.errormsg"
            ),
          },
          nie: {
            title: t(
              "PersonalDataUtils.literals.idinfo.documentType.nie.title"
            ),
            subtitle: t(
              "PersonalDataUtils.literals.idinfo.documentType.nie.subtitle"
            ),
            errormsg: t(
              "PersonalDataUtils.literals.idinfo.documentType.nie.errormsg"
            ),
          },
          passport: {
            title: t(
              "PersonalDataUtils.literals.idinfo.documentType.passport.title"
            ),
            subtitle: t(
              "PersonalDataUtils.literals.idinfo.documentType.passport.subtitle"
            ),
            errormsg: t(
              "PersonalDataUtils.literals.idinfo.documentType.passport.errormsg"
            ),
          },
        },
        slotNames: {
          slot1: t("PersonalDataUtils.literals.idinfo.slotNames.slot1"),
          slot2: t("PersonalDataUtils.literals.idinfo.slotNames.slot2"),
          slot3: t("PersonalDataUtils.literals.idinfo.slotNames.slot3"),
        },
        label: t("PersonalDataUtils.literals.idinfo.label"),
      },
      deleteinfo: {
        title: t("PersonalDataUtils.literals.deleteinfo.title"),
        subtitle: t("PersonalDataUtils.literals.deleteinfo.subtitle"),
        deletebutton: t("PersonalDataUtils.literals.deleteinfo.deletebutton"),
      },
      addressinfo: {
        literals: {
          title: t("PersonalDataUtils.literals.addressinfo.literals.title"),
          subtitle: t(
            "PersonalDataUtils.literals.addressinfo.literals.subtitle"
          ),
          streetAddress: t(
            "PersonalDataUtils.literals.addressinfo.literals.streetAddress"
          ),
          postalCode: t(
            "PersonalDataUtils.literals.addressinfo.literals.postalCode"
          ),
          locality: t(
            "PersonalDataUtils.literals.addressinfo.literals.locality"
          ),
          region: t("PersonalDataUtils.literals.addressinfo.literals.region"),
          country: t("PersonalDataUtils.literals.addressinfo.literals.country"),
        },
      },
    },
  };
}
